import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';

/**
 * A custom element that allows the user to clean a search input.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} searchPageInput - The search input element.
 * @extends {Component<Refs>}
 */
class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput'];

  /**
   * Handles the keydown event on the search input and resets the search when
   * empty and Escape is pressed.
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  handleKeyDown = debounce((event) => {
    const value = this.refs.searchPageInput.value.trim();

    if (event.key === 'Escape' && value === '') {
      this.#submitEmptySearch();
    }
  }, 100);

  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;

    searchInput.focus();
    searchInput.value = '';

    if (this.#isEmptyState()) return;

    searchInput.form?.submit();
  }

  #isEmptyState = () => {
    const url = new URL(window.location.href);
    const queryParam = url.searchParams.get('q') ?? '';

    return queryParam.trim() === '';
  };
}

if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}

// custom js ----------------------------------------------------------------------------------------------------


document.addEventListener('DOMContentLoaded', () => {
  const LIMITS = { product: 9, article: 6, page: 9 }, WINDOW = 4;
  const tabs = document.querySelectorAll('.tab-for-search-itms'), blocks = document.querySelectorAll('.search-extra-results');
  const scrollTarget = document.querySelector('.content-image-block');
  const searchInput = document.querySelector('.search-page-input');
  if (searchInput) {
    const form = searchInput.closest('form');
    if (form) {
      const hiddenType = form.querySelector('input[name="type"]');
      if (hiddenType) hiddenType.remove();
    }
  }
  const counts = {
    product: document.querySelectorAll('.product-grid__item').length,
    article: document.querySelectorAll('.article-search-items-main').length,
    page: document.querySelectorAll('.page-search-link').length
  };
  tabs.forEach(tab => {
    const type = tab.dataset.search;
    tab.textContent = tab.textContent.replace(/\(.*?\)/, `(${counts[type] || 0})`);
  });
  const SVG_PREV = `<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
  const SVG_NEXT = `<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
  function init(block) {
    if (block._init) return;
    block._init = true;
    const type = block.dataset.search, limit = LIMITS[type], list = block.querySelector('ul'), pager = block.querySelector('.custom-pagination');
    const items = [...list.children], total = Math.ceil(items.length / limit);

    const render = (p, doScroll = false) => {
      pager.style.display = total <= 1 ? 'none' : 'flex';
      list.innerHTML = '';
      items.slice((p - 1) * limit, p * limit).forEach(el => list.appendChild(el.cloneNode(true)));
      if (total <= 1) return;

      pager.innerHTML = '';
      const addBtn = (content, pg, dis = false, act = false) => {
        const b = document.createElement('button');
        b.innerHTML = content; b.disabled = dis;
        if (act) b.className = 'active';
        if (!dis && pg) b.onclick = () => render(pg, true);
        pager.appendChild(b);
      };

      addBtn(SVG_PREV, p - 1, p === 1);
      let s = Math.max(1, Math.min(p - 1, total - WINDOW + 1)), e = Math.min(total, s + WINDOW - 1);
      if (s > 1) { addBtn(1, 1); if (s > 2) addBtn('...', 0, true); }
      for (let i = s; i <= e; i++) addBtn(i, i, false, i === p);
      if (e < total) { if (e < total - 1) addBtn('...', 0, true); addBtn(total, total); }
      addBtn(SVG_NEXT, p + 1, p === total);
      if (doScroll && scrollTarget) {
        window.scrollTo({ top: scrollTarget.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      }
    };
    render(1, false);
  }
  const showTab = (type) => {
    blocks.forEach(b => {
      const match = b.dataset.search === type;
      b.style.display = match ? 'block' : 'none';
      if (match) init(b);
    });
    tabs.forEach(t => t.classList.toggle('active', t.dataset.search === type));
  };

  tabs.forEach(t => t.onclick = (e) => { e.preventDefault(); showTab(t.dataset.search); });
  showTab('product');
});


document.querySelector('.search-page-input__parent search-page-input-component .search__icon').addEventListener('click', function (e) {
  const tab = e.target.closest('.search-page-input__parent search-page-input-component .search__icon');
  const input = tab.closest('search-page-input-component').querySelector('input.search-page-input');
  input.form.submit();
});

document.addEventListener("DOMContentLoaded", function () {
  const pageList = document.querySelector(".search-pages-results");
  const noResults = document.querySelector(".pages_no-results");
  if (pageList) {
    const items = pageList.querySelectorAll(".page-search-link");
    if (items.length === 0) {
      pageList.style.display = "none";
      if (noResults) noResults.style.display = "grid";
    } else {
      pageList.style.display = "grid";
      if (noResults) noResults.style.display = "none";
    }
  }
});
